<div
    class="element-card"
    [class.is-new]="isNew"
    appClickOutside
    (clicked)="clickedOutsideCard($event)"
>
    <div
        class="content-header"
        [class.content-header-closed]="!isEditing"
        (click)="toggle()"
    >
        <div class="name">
            <div class="icon-name">
                <img
                    class="software-icon"
                    [src]="info.image"
                    alt="source-software-logo"
                />
                <div class="row">
                    <div class="name" [class.draft]="isNew">
                        {{ typeDisplay | titlecase }} - {{ integration.name }}
                    </div>
                    <span [class]="status" *ngIf="status; else statusLoader">{{ status | uppercase }}</span>
                </div>
            </div>
        </div>
        <div class="right">
            <app-custom-button
                size="auto"
                type="basic"
                [icon]="isEditing ? 'expand_less' : 'expand_more'"
                (buttonClick)="toggle()"
            ></app-custom-button>
        </div>
    </div>
    <div class="content" *ngIf="isEditing" [formGroup]="cardForm" [@inOutAnimation]>
        <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>

            <input
                matInput
                autocomplete="off"
                title="Name"
                label="Name"
                placeholder="Name"
                type="text"
                formControlName="name"
            />
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Connection String</mat-label>
            <mat-icon
                *ngIf="isConnectionStringDirty && connectionInput.type === 'text'"
                (click)="connectionInput.type = 'password'"
            >
                visibility_off
            </mat-icon>
            <mat-icon
                *ngIf="isConnectionStringDirty && connectionInput.type === 'password'"
                (click)="connectionInput.type = 'text'"
            >
                visibility
            </mat-icon>
            <input
                #connectionInput
                matInput
                autocomplete="off"
                label="Connection String"
                title="Connection String"
                placeholder="Connection String"
                type="password"
                formControlName="connectionString"
            />
        </mat-form-field>
        <div class="button-containers">
            <div class="delete-button-container">
                <app-custom-button
                    data-testid="delete-filter-button"
                    class="deleteButton"
                    icon="delete"
                    type="link"
                    (buttonClick)="onDelete()"
                >
                </app-custom-button>
            </div>
            <div class="save-buttons-container">
                <app-custom-button
                    color="primary"
                    text="Discard"
                    class="small"
                    type="stroked"
                    size="small"
                    (buttonClick)="onDiscard()"
                >
                </app-custom-button>
                <app-custom-button
                    color="primary"
                    text="Save Changes"
                    class="small"
                    type="flat"
                    size="small"
                    (buttonClick)="onSubmit()"
                    [disabled]="!formHasChange || !isFormValid"
                >
                </app-custom-button>
            </div>
        </div>
    </div>
</div>


<ng-template #statusLoader>
    <ngx-skeleton-loader
        id="loader"
        count="1"
        appearance="line"
        [theme]="{
            width: '70px'
        }"
    >
    </ngx-skeleton-loader>
</ng-template>